export const ITEM_STRUCTURE_TYPE = "פריט" as const;
export const ITEMS_PATH = "/items";
export const ITEMS_BREADCRUMB = { ledger: "כרטסות", list: "פריטים/מלאי" } as const;
export const ITEMS_STRUCTURE_CRUMBS = {
  search: "הגדרת מבנה חיפוש",
  browse: "הגדרת מבנה דפדוף",
} as const;
export const SEARCH_TABLE_STYLE = {
  backgroundColor: "rgb(35, 48, 68)",
  padding: 5,
  marginButton: 20,
} as const;
